var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"compare",attrs:{"id":"compare"}},[_c('h2',[_vm._v("Compare Our Plans")]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"-0.5rem"}},[_vm._v("\n    See which plan is best for you by comparing the features offered.\n  ")]),_vm._v(" "),(_vm.isSmallerScreen)?_c('PricingCompareMobile'):_c('PricingCompareTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }